import { useState, useContext, useEffect } from "react";
import styled, { ThemeProvider } from "styled-components";
import TopBar from "./components/TopBar";
import Footer from "./components/Footer";
import SurveyWrapper from "./components/SurveyPage";
import ErrorModal from "./components/ErrorModal";
import SurveyContent from "./components/SurveyContent";
import { AnswersContext } from "./context/AnswersContext";
import { DataContext } from "./context/DataContext";
import { GlobalStylesContext } from "./context/GlobalStylesContext";
import LanguageSelect from "./components/LanguageSelect";
import LoadingBar from "react-top-loading-bar";
import "./App.css";
import MasterWrapper from "./components/MasterWrapper";
import { lightTheme, darkTheme } from "./theme/theme";

const specialSidTheme = {
  ...lightTheme,
  bgPrimary: "#FAF9F6",
  bgSecondary: "#F4F1EA",
  bgTertiary: "#ECE8DF",
  textPrimary: "#18314D",
  textSecondary: "#18314D",
  textMuted: "#707070",
  borderPrimary: "#D8D2C8",
  borderSecondary: "#707070",
  borderFocus: "#3C858B",
  headerBg: "rgba(250, 249, 246, 0.9)",
  footerBg: "#FAF9F6",
  cardBg: "#FAF9F6",
  inputBg: "#FAF9F6",
  inputBorder: "#D8D2C8",
  inputBorderHover: "#707070",
  inputBorderFocus: "#3C858B",
  progressBg: "#D8D2C8",
  progressFill: "#3C858B",
  selectedBg: "#E6F3F4",
  selectedBorder: "#3C858B",
  accentPrimary: "#3C858B",
  accentPrimaryHover: "#18314D",
  accentLight: "#E6F3F4",
  accentDark: "#18314D",
  buttonBgColorNormal: "#3C858B",
  buttonBgColorHover: "#18314D",
  buttonHoverFilter: "none",
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${props => props.theme.bgPrimary};
  transition: background-color 0.3s ease;
`;

const App = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const { answeredQuestions, setAnsweredQuestions } =
    useContext(AnswersContext);
  const {
    paginatedData,
    surveyData,
    surveyMetaData,
    defaultLanguage,
    languageArray,
    chosenLanguage,
    setChosenLanguage,
    fetchError,
    messageError,
    currentPage,
    setCurrentPage,
    loaderRef,
    thankYou
  } = useContext(DataContext);
  
  const { 
    isDark, 
    accentPrimary, 
    accentPrimaryHover, 
    accentLight, 
    accentDark,
    isSpecialTheme,
  } = useContext(GlobalStylesContext);
  
  // Create theme object with custom accent colors
  const currentTheme = isDark ? darkTheme : lightTheme;
  const themeWithAccents = isSpecialTheme ? specialSidTheme : {
    ...currentTheme,
    accentPrimary,
    accentPrimaryHover,
    accentLight,
    accentDark,
  };

    return (
      <ThemeProvider theme={themeWithAccents}>
        <Wrapper>
        <TopBar />
        <LoadingBar color="#316dd5" ref={loaderRef} />
        {(paginatedData[0]?.length || fetchError) || thankYou ? (
          <SurveyContent
            fetchError={fetchError}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            currentQuestionIndex={currentQuestionIndex}
            localizedText={surveyMetaData}
            chosenLanguage={chosenLanguage ? chosenLanguage : defaultLanguage}
            loaderRef={loaderRef}
          />
        ) : languageArray.length && languageArray.length > 1 &&
          !window.location.href.includes("language") && (!window.location.href.includes("pid") || !languageArray.map(language => language.pid).includes(window.location.href.split('pid=')[1].split('&')[0]))  ? (
          <MasterWrapper flexDirection="column" padding="15px 4px">
            <LanguageSelect
              loaderRef={loaderRef}
              localizedText={surveyMetaData}
              defaultLanguage={defaultLanguage}
              languageArray={languageArray}
              setChosenLanguage={setChosenLanguage}
              chosenLanguage={chosenLanguage ? chosenLanguage : defaultLanguage}
            />
          </MasterWrapper>
        ) : messageError && currentPage === 1 ? (
          <MasterWrapper flexDirection="column" padding="15px 4px">
            <div
              style={{ maxWidth: "768px", margin: "0 auto", padding: "15 10px" }}
            >
              <ErrorModal chosenLanguage={chosenLanguage} />
            </div>
          </MasterWrapper>
        ) : (
          <MasterWrapper flexDirection="column" padding="15px 4px">
            <p style={{ marginLeft: "15px" }}>Loading...</p>
          </MasterWrapper>
        )}
        <Footer
          localizedText={surveyMetaData}
          chosenLanguage={chosenLanguage ? chosenLanguage : defaultLanguage}
        />
      </Wrapper>
      </ThemeProvider>
    );

};

export default App;
